import { createSelector } from 'reselect'
import { path } from 'ramda'
import { NAMESPACE } from '../constants'

const getState = (state: any) => state

export const supportStaffState = createSelector(getState, s => path([NAMESPACE], s))

export const isAgencySelectionModalOpen = createSelector(supportStaffState, s => path(['isOpen'], s))
